import { render, staticRenderFns } from "./DocumentFieldDatetime.vue?vue&type=template&id=2c731f00&"
import script from "./DocumentFieldDatetime.vue?vue&type=script&lang=js&"
export * from "./DocumentFieldDatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports